import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import youtubeThumbnailService from '../../services/youtubeThumbnailService';
import { showMsg } from '../../services/library';
import { RESOLUTION_YT_3x2, RESOLUTION_YT_4x3, TEXT_TYPE } from '../../constants/commonConst';

const REQ_YOUTUBETHUMBNAIL = 'youtubethumbnail/';

// Get templatelist and fontlist
export const fetchAllThumbnailsReq = createAsyncThunk(
  `${REQ_YOUTUBETHUMBNAIL}`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await youtubeThumbnailService.getAllThumbnails(data);
      if (response?.status) {
        return response?.data[0] || null;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

// Add thumbnail
export const saveThumbnailReq = createAsyncThunk(
  `${REQ_YOUTUBETHUMBNAIL}saveThumbnail`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await youtubeThumbnailService.saveThumbnail(data);
      if (response?.status) {
        return response?.data[0] || null;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

// Update thumbnail
// export const updateThumbnailReq = createAsyncThunk(
//   `${REQ_YOUTUBETHUMBNAIL}updateThumbnail`,

//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await youtubeThumbnailService.updateThumbnail(data);
//       if (response?.status) {
//         return response?.data[0] || null;
//       } else {
//         showMsg(response?.errors, 'error');
//         return rejectWithValue(response?.errors);
//       }
//     } catch (error) {
//       showMsg(error, 'error');
//       return rejectWithValue(error);
//     }
//   }
// );

// Delete thumbnail
export const deleteThumbnailReq = createAsyncThunk(
  `${REQ_YOUTUBETHUMBNAIL}deleteThumbnail`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await youtubeThumbnailService.deleteThumbnail(data);
      if (response?.status) {
        return response || null;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

const youtubeThumbnailSlice = createSlice({
  name: 'YoutubeThumbnail',
  initialState: {
    activeType: null,
    youtubeOverlayDetails: [],
    imageResolution: RESOLUTION_YT_3x2,
    // thumbnails: [],
    // selectedThumbnail: null,
    // tempName: '',
    // toggleNameModal: false,
    exportShots: [],
    selectedShot: 0,
    fontList: [],
    isFontLoading: true,
    fontLibraryToggle: false,
    previewToggle: false,
    previewUrl: null
  },

  reducers: {
    handleActiveType: {
      reducer(state, action) {
        state.activeType = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleYoutubeOverlayDetails: {
      reducer(state, action) {
        state.youtubeOverlayDetails = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleImageResolution: {
      reducer(state, action) {
        state.imageResolution = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleExportShots: {
      reducer(state, action) {
        state.exportShots = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSelectedShot: {
      reducer(state, action) {
        state.selectedShot = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },

    // handleThumbnails: {
    //   reducer(state, action) {
    //     state.thumbnails = action.payload;
    //   },
    //   prepare(e) {
    //     return { payload: e };
    //   }
    // },
    // handleSelectedThumbnail: {
    //   reducer(state, action) {
    //     state.selectedThumbnail = action.payload;
    //   },
    //   prepare(e) {
    //     return { payload: e };
    //   }
    // },
    // handleTempName: {
    //   reducer(state, action) {
    //     state.tempName = action.payload;
    //   },
    //   prepare(e) {
    //     return { payload: e };
    //   }
    // },
    // handleToggleNameModal: {
    //   reducer(state, action) {
    //     state.toggleNameModal = action.payload;
    //   },
    //   prepare(e) {
    //     return { payload: e };
    //   }
    // },
    handleFontList: {
      reducer(state, action) {
        state.fontList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleIsFontLoading: {
      reducer(state, action) {
        state.isFontLoading = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFontLibraryToggle: {
      reducer(state, action) {
        state.fontLibraryToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePreviewToggle: {
      reducer(state, action) {
        state.previewToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePreviewUrl: {
      reducer(state, action) {
        state.previewUrl = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  },

  extraReducers: builder => {
    builder
      // #region fetchAllThumbnailsReq
      .addCase(fetchAllThumbnailsReq.pending, state => {
        state.isFontLoading = true;
        state.fontList = [];
      })
      .addCase(fetchAllThumbnailsReq.fulfilled, (state, action) => {
        const { dealerIs43, thumbnailDetails, exportShots, fontFileList } = action.payload;
        let textCounter = 1,
          imageCounter = 1;
        state.imageResolution = dealerIs43 ? RESOLUTION_YT_4x3 : RESOLUTION_YT_3x2;
        state.youtubeOverlayDetails =
          thumbnailDetails?.map((d, index) => ({
            ...d,
            overlayNumber: d?.ytd_type === TEXT_TYPE ? textCounter++ : imageCounter++,
            temp_id: index + 1
          })) || [];
        state.exportShots = exportShots;
        state.selectedShot = thumbnailDetails?.length > 0 ? thumbnailDetails[0].yt_shotid : 0;
        // const thumbnailsList =
        //   youtubeThumbnailDetails?.map(d => ({
        //     ...d,
        //     label: d.yt_name,
        //     value: d.yt_id
        //   })) || [];
        // // ------Library------
        // state.thumbnails = thumbnailsList;
        state.isFontLoading = false;
        state.fontList =
          fontFileList?.map(d => ({
            ...d,
            label: d.vf_filename,
            value: d.vf_id
          })) || [];
      })
      .addCase(fetchAllThumbnailsReq.rejected, state => {
        state.isFontLoading = false;
      })
      // #endregion
      // #region saveThumbnailReq
      .addCase(saveThumbnailReq.fulfilled, (state, action) => {
        const { thumbnailDetails } = action.payload;
        let textCounter = 1,
          imageCounter = 1;

        state.youtubeOverlayDetails = thumbnailDetails.map((d, index) => ({
          ...d,
          overlayNumber: d?.ytd_type === TEXT_TYPE ? textCounter++ : imageCounter++,
          temp_id: index + 1
        }));
        // tempObject.value = tempObject.yt_id;
        // tempObject.label = tempObject.yt_name;
        // tempObject.overlayArr = thumbDetails;
        // const updatedList = [...state.thumbnails, tempObject];
        // state.thumbnails = updatedList;
        // state.tempName = '';
        // state.selectedThumbnail = tempObject || null;
        showMsg('Thumbnail saved successfully', 'success');
      })
      // #endregion
      // #region updateThumbnailReq
      // .addCase(updateThumbnailReq.fulfilled, (state, action) => {
      //   const { updatedIds, thumbDetails } = action.payload;
      //   showMsg('Template updated successfully.', 'success');
      //   state.thumbnails = state?.thumbnails?.map(d => {
      //     return {
      //       ...d,
      //       overlayArr: d.yt_id === state?.selectedThumbnail?.value ? thumbDetails || [] : d.overlayArr,
      //       yt_overlay_ids: d.yt_id === state?.selectedThumbnail?.value ? updatedIds || [] : d.yt_overlay_ids
      //     };
      //   });
      // })
      // #endregion
      // #region deleteThumbnailReq
      .addCase(deleteThumbnailReq.rejected, () => {
        showMsg('Thumbnail is not deleted');
      });
    // #endregion
  }
});

export const {
  handleYoutubeOverlayDetails,
  handleImageResolution,
  handleActiveType,
  handleExportShots,
  handleSelectedShot,
  // handleThumbnails,
  handleSelectedThumbnail,
  // handleTempName,
  // handleToggleNameModal,
  handleFontList,
  handleIsFontLoading,
  handleFontLibraryToggle,
  handlePreviewToggle,
  handlePreviewUrl
} = youtubeThumbnailSlice.actions;

export default youtubeThumbnailSlice.reducer;
